import { $, $all, on } from "@olmokit/dom";
import { dataLayerShareOn } from "components/Datalayer";
import "./index.scss";

/**
* Component: ShareOn
*/
export function ShareOn() {
  console.log("ShareOn mounted.");

  const houzzBtn = $('#ShareOn:houzzBtn');
  var monitor = setInterval(function(){
      var elem = document.activeElement;
      if(elem && elem.tagName == 'IFRAME'){
          clearInterval(monitor);
          console.log('share on: houzz');
          dataLayerShareOn(
            'houzz', 
            houzzBtn.getAttribute('data-element'), 
            houzzBtn.getAttribute('data-clicked') 
          );
      }
  }, 100);

  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('ShareOn:facebookBtn')) {
      console.log('share on: facebook');
      dataLayerShareOn(
        'facebook', 
        event.target.getAttribute('data-element'), 
        event.target.getAttribute('data-clicked')
      );
    } else if (event.target.classList.contains('ShareOn:linkedinBtn')) {
      console.log('share on: linkedin');
      dataLayerShareOn(
        'linkedin', 
        event.target.getAttribute('data-element'), 
        event.target.getAttribute('data-clicked')
      );
    } else if (event.target.classList.contains('ShareOn:pinterestBtn')) {
      console.log('share on: pinterest');
      dataLayerShareOn(
        'pinterest', 
        event.target.getAttribute('data-element'), 
        event.target.getAttribute('data-clicked')
      );
    } 
  })
  
  /* const h1 = $('.h1').getAttribute('data-title');
  var monitor = setInterval(intervals, 100);
  function intervals() {
    var elem = document.activeElement;
    if(elem && elem.tagName == 'IFRAME'){
      // console.dir(elem);
      // if (elem.src.contains('houzz')) {
      //     console.log('share on: houzz');
      // }
      if (elem.id.indexOf('PIN')) {
        console.log('share on: pinterest');
      } else {
        console.log('share on: houzz');
        dataLayerShareOn('houzz', '', h1);
      }
      clearInterval(monitor);
      monitor = setInterval(exitIframe.bind(null, elem), 100);
    }
  }
  function exitIframe(iframe){
    var elem = document.activeElement;
    if((elem && elem.tagName != 'IFRAME') || (elem && elem != iframe)){
      console.log('exited');
      clearInterval(monitor);
      monitor = setInterval(intervals, 100);
    }
  }
  document.addEventListener('click', function (event) {
    if (event.target.classList.contains('ShareOn:facebookBtn')) {
      console.log('share on: facebook');
      dataLayerShareOn('facebook', '', h1);
    } else if (event.target.classList.contains('ShareOn:linkedinBtn')) {
      console.log('share on: linkedin');
      dataLayerShareOn('linkedin', '', h1);
    } else if (event.target.classList.contains('ShareOn:pinterestBtn')) {
      console.log('share on: pinterest');
      dataLayerShareOn('pinterest', '', h1);
    } 
  }) */
  
}
